// import menuData from './menuData'
//
// // 加载json的菜单配置
// function getMenuChildren () {
//   let childrenPath = []
//   //console.log(menuData)
//   for (let i in menuData) {
//     //console.log("-->" + menuData[i].name)
//     let component = () => import('@' + menuData[i].component)
//     const item = {
//       path: menuData[i].path,
//       name: menuData[i].name,
//       index: menuData[i].index,
//       meta: menuData[i].meta,
//       component: component
//     }
//     //console.log("-->999");
//     childrenPath.push(item)
//   }
//   //console.log("=============")
//   //console.log(childrenPath)
//   return childrenPath
// }

const url = [
  // 登录页面 注册页面 密码找回页面
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue')
  }, {
    path: '/error404',
    name: 'Error 404',
    index: 2,
    component: () => import('@/views/error/Error404.vue')
  }, {
    path: '/register',
    name: 'Register',
    index: 3,
    component: () => import('@/views/auth/Register.vue')
  }, {
    path: '/forgot',
    name: 'Forgot',
    index: 4,
    component: () => import('@/views/auth/Forgot.vue')
  },
  // 主页面
  {
    path: '',
    component: () => import('@/layout/normal/Main.vue'),
    //children: getMenuChildren()
    children: [{
      path: '/dashboards/classic-dashboard',
      name: 'Classic Dashboard',
      index: 50,
      meta: {
        breadcrumb: [{
          title: 'Dashboards',
          url: '/dashboards/classic-dashboard'
        }, {
          title: 'Classic Dashboard',
          active: true
        }]
      },
      component: () => import('@/views/dashboards/ClassicDashboard.vue')
    },{
      path: '/notifications/recent-notification',
      name: '消息',
      index: 51,
      meta: {
        breadcrumb: [{
          title: '消息',
          url: '/notifications/recent-notification'
        }, {
          title: '消息',
          active: true
        }]
      },
      component: () => import('@/views/notifications/RecentNotifications.vue')
    },{
      path: '/workbench/workbench',
      name: '工作台',
      index: 51,
      meta: {
        breadcrumb: [{
          title: '工作台',
          url: '/workbench/workbench'
        }, {
          title: '工作台',
          active: true
        }]
      },
      component: () => import('@/views/workbench/Workbench.vue')
    },{
      path: '/workbench/daildetails',
      name: '快捷拨打详情',
      index: 51,
      meta: {
        breadcrumb: [{
          title: '快捷拨打详情',
          url: '/workbench/daildetails'
        }, {
          title: '快捷拨打详情',
          active: true
        }]
      },
      component: () => import('@/views/workbench/DailDetails.vue')
    },{
      path: '/workbench/tasklistdetails',
      name: '任务列表',
      index: 51,
      meta: {
        breadcrumb: [{
          title: '任务列表',
          url: '/workbench/tasklistdetails'
        }, {
          title: '任务列表',
          active: true
        }]
      },
      component: () => import('@/views/workbench/TaskListDetails.vue')
    },{
      path: '/workbench/taskdetails',
      name: '任务详情',
      index: 51,
      meta: {
        breadcrumb: [{
          title: '任务详情',
          url: '/workbench/taskdetails'
        }, {
          title: '任务详情',
          active: true
        }]
      },
      component: () => import('@/views/workbench/TaskDetails.vue')
    },{
      path: '/workbench/wordlistdetails',
      name: '话术列表',
      index: 51,
      meta: {
        breadcrumb: [{
          title: '话术列表',
          url: '/workbench/wordlistdetails'
        }, {
          title: '话术列表',
          active: true
        }]
      },
      component: () => import('@/views/workbench/WordListDetails.vue')
    },{
      path: '/workbench/customercenter',
      name: '客户中心',
      index: 51,
      meta: {
        breadcrumb: [{
          title: '工作台',
          url: '/workbench/workbench'
        }, {
          title: '客户中心',
          active: true
        }]
      },
      component: () => import('@/views/workbench/CustomerCenter.vue')
    }
    ,{
      path: '/finance/fiance',
      name: '财务',
      index: 51,
      meta: {
        breadcrumb: [{
          title: '财务',
          url: '/finance/fiance'
        }, {
          title: '财务',
          active: true
        }]
      },
      component: () => import('@/views/finance/Finance.vue')
    },{
      path: '/keyboard/dialkeyboard',
      name: '拨号键',
      index: 52,
      component: () => import('@/views/keyboard/DialKeyboard.vue')
    },{
      path: '/crm/mycustomer',
      name: '我的客户',
      index: 52,
      component: () => import('@/views/crm/MyCustomer.vue')
    },{
      path: '/crm/customersea',
      name: '客户公海',
      index: 53,
      component: () => import('@/views/crm/CustomerSea.vue')
    },{
        path: '/workbench/nodes/addedittask',
        name: '创建任务',
        index: 54,
        component: () => import('@/views/workbench/nodes/AddEditTask.vue')
      },{
        path: '/workbench/nodes/recordmanage',
        name: '路由界面',
        index: 55,
        component: () => import('@/views/workbench/nodes/RecordManage.vue')
      }
    ]},

  // 页面找不到时
  {
    path: '*',
    redirect: '/Error404'
  }
]

export default url



// WEBPACK FOOTER //
// ./src/router/url.js